"use strict";
//Simple Version
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDebounceEffect = exports.FunctionUseId = exports.FunctionUseDebounce = exports.FunctionUseParams = void 0;
const React = __importStar(require("react"));
// export const FunctionUseParams = (query = {}) => {
//   const queryKeys = Object.keys(query);
//   let queryString = "";
//   if (queryKeys.length > 0) {
//     const searchParams = new URLSearchParams();
//     for (const queryKey of queryKeys) {
//       searchParams.append(queryKey, query[queryKey]);
//     }
//     queryString = `?${searchParams.toString()}`;
//   }
//   return queryString;
// };
//New Version
const FunctionUseParams = (query = {}) => {
    try {
        const allKeys = Object.entries(query);
        let newQueryNonEmpty = {};
        let thisLength = 0;
        allKeys.forEach((row) => {
            const thisValue = String(row[1] || "");
            if (thisValue !== undefined && thisValue !== null && thisValue !== "") {
                newQueryNonEmpty[row[0]] = row[1];
                thisLength++;
            }
        });
        const queryKeys = Object.keys(newQueryNonEmpty);
        let queryString = "";
        if (thisLength > 0) {
            const searchParams = new URLSearchParams();
            for (const queryKey of queryKeys) {
                searchParams.append(queryKey, query[queryKey]);
            }
            queryString = `?${searchParams.toString()}`;
        }
        return queryString;
    }
    catch (error) {
        console.error("FunctionUseParams", error);
    }
};
exports.FunctionUseParams = FunctionUseParams;
const FunctionUseDebounce = (value, delay) => {
    const [debouncedValue, setDebouncedValue] = React.useState(value);
    React.useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);
        return () => {
            clearTimeout(handler);
        };
    }, [value]);
    return debouncedValue;
};
exports.FunctionUseDebounce = FunctionUseDebounce;
const FunctionUseId = () => {
    const [id, setId] = React.useState("");
    React.useEffect(() => {
        let Mount = true;
        if (id === "") {
            setId(Math.random().toString(36).substr(2, 9));
        }
        return () => {
            Mount = false;
        };
    }, []);
    return id;
};
exports.FunctionUseId = FunctionUseId;
const useDebounceEffect = (effect, deps, delay) => {
    const callback = React.useCallback(effect, deps);
    React.useEffect(() => {
        const timeoutId = setTimeout(() => {
            callback();
        }, delay);
        return () => {
            clearTimeout(timeoutId);
        };
    }, [callback, delay]);
};
exports.useDebounceEffect = useDebounceEffect;
